import { WidgetsProfileMain } from '@/widgets/profile';

export const PagesProfileMain = () => <WidgetsProfileMain />;
